import { render, staticRenderFns } from "./trust-loan-approval-dialog.vue?vue&type=template&id=6ecc5498&scoped=true&"
import script from "./trust-loan-approval-dialog.vue?vue&type=script&lang=js&"
export * from "./trust-loan-approval-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc5498",
  null
  
)

export default component.exports